import AuthService from 'lib/auth/AuthService';
import { AUTH_ACTIONS } from '../v1/auth/auth.constants.js';
import { emitServerUnreachable } from '../../v5/platform/server-unreachable/serverUnreachableEvent';

/**
 * v1 loadAuth runs in parallel with RTK bootstrap thunks (see Routes.jsx).
 * On failure the auth slice resets loggedIn but the session token remains —
 * PrivateRoute can spin forever. Emit the global server-unreachable screen instead.
 */
const bootstrapFailureMiddleware = () => next => action => {
  if (
    action?.type === AUTH_ACTIONS.LOAD_AUTH_FAILURE &&
    AuthService.isAuthenticated()
  ) {
    emitServerUnreachable(action.error, 'session');
  }
  return next(action);
};

export default bootstrapFailureMiddleware;
